import PropTypes from 'prop-types';

// Linha "rótulo + conteúdo" da seção Negociação.
//
// Existe como componente porque a coluna do rótulo precisa ter largura FIXA e
// igual em todas as linhas — inclusive nas que são renderizadas pelo ModalNegocio
// (Criado em / Atualização) e não por aqui. Com `min-w`, rótulos longos como
// "Status da Venda" esticavam a coluna e empurravam só aquele controle para a
// direita, deixando os campos desalinhados entre si.
//
// 120px cabe o maior rótulo em uso ("Status da Venda") em uma linha só; se algum
// rótulo novo quebrar em duas linhas, o `items-center` mantém o controle centrado.
// Exportada à parte para as demais seções do painel (Contatos, Campos
// Personalizados) usarem a MESMA coluna e o olho descer reto pelo painel inteiro.
export const NEGOCIO_ROW_LABEL_W = 'w-[120px] shrink-0';

export const NEGOCIO_ROW_LABEL =
    `${NEGOCIO_ROW_LABEL_W} text-[11px] font-semibold uppercase tracking-wider leading-tight text-gray-500 dark:text-[#8b8d90]`;

export default function NegocioInfoRow({ label, children }) {
    return (
        <div className="flex items-center gap-3">
            <label className={NEGOCIO_ROW_LABEL}>{label}</label>
            <div className="flex-1 min-w-0">{children}</div>
        </div>
    );
}

NegocioInfoRow.propTypes = {
    label: PropTypes.node.isRequired,
    children: PropTypes.node,
};
